import { CirclePlus, Share2 } from 'lucide-react';

const AlbumHeader = ({ title, artist, coverImage, releaseYear, totalTracks, duration }) => {
  return (
    <div className="flex flex-col md:flex-row items-center gap-8 mb-8 pt-20">
      <img
        src={coverImage}
        alt={title}
        className="w-48 h-48 md:w-64 md:h-64 object-cover rounded-lg"
      />
      <div className="text-center md:text-left flex flex-col justify-between h-26 md:h-64 w-full">
        <div className="mb-2 flex justify-between">
          <h1 className="text-4xl font-bold">{title}</h1>
          <div className="flex gap-4">
            <CirclePlus className="cursor-pointer hover:text-green-500" />
            <Share2 className="cursor-pointer hover:text-green-500" />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <p className="text-xl text-gray-400">{artist}</p>
          <span className="text-sm text-gray-400">
            • {releaseYear} • {totalTracks} tracks, {duration}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AlbumHeader;